import axios from "axios";

export const SUFFERINGS = "sufferings";

export const storeSuffering = (data) => {
  return axios.post(`${SUFFERINGS}`, data);
}

export const getSufferingsByCaseId = (caseId) => {
  return axios.get(`${SUFFERINGS}/${caseId}`);
}

export const isCompleteSuffering = (s) =>
  !!(s?.icd && s?.icdDescription && s?.icdSpeciality && s?.cpt && s?.cptDescription && s?.cptSpeciality);

export const hasAnyCompleteSuffering = async (caseId) => {
  try {
    const response = await getSufferingsByCaseId(caseId);
    return (response?.data || []).some(isCompleteSuffering);
  } catch (err) {
    console.error("Error validando padecimientos:", err);
    return false;
  }
};
